import { runeSpecialFactor } from '.'
import type { RuneAffixType, RuneSpecAttrType } from '@/types/rune'

export const runeAffixCollection: RuneAffixType = {
  thump: {
    name: '重击',
    desc: ({ extraRate, extraDamage }, soulType) => {
      const mag = soulType === 1 ? 1.2 : 1
      if (extraRate) {
        const res = Number((runeSpecialFactor.thump.extraRate * mag * extraRate).toFixed(2))
        return `概率 + <span class="grow">${res}</span> 倍`
      } else {
        const res = Number((runeSpecialFactor.thump.extraDamage * mag * extraDamage).toFixed(2))
        return `额外造成伤害 + <span class="grow">${res}</span> 倍`
      }
    },
  },
  harvest: {
    name: '收割',
    desc: ({ extraHpPercent, extraMultiplier }, soulType) => {
      const mag = soulType === 3 ? 1.2 : 1
      if (extraHpPercent) {
        const res = Number((runeSpecialFactor.harvest.extraHpPercent * mag * extraHpPercent).toFixed(2))
        return `触发要求降低 <span class="grow">${res}</span> 倍`
      } else {
        const res = Number((runeSpecialFactor.harvest.extraMultiplier * mag * extraMultiplier).toFixed(2))
        return `伤害加成增加 <span class="grow">${res}</span> 倍`
      }
    },
  },
  assault: {
    name: '冲锋',
    desc: ({ extraHpPercent, extraMultiplier }, soulType) => {
      const mag = soulType === 1 ? 1.2 : 1
      if (extraHpPercent) {
        const res = Number((runeSpecialFactor.assault.extraHpPercent * mag * extraHpPercent).toFixed(2))
        return `触发要求降低 <span class="grow">${res}</span> 倍`
      } else {
        const res = Number((runeSpecialFactor.assault.extraMultiplier * mag * extraMultiplier).toFixed(2))
        return `伤害加成增加 <span class="grow">${res}</span> 倍`
      }
    },
  },
  chasing: {
    name: '追击',
    desc: ({ extraValue }, soulType) => {
      const mag = soulType === 3 ? 1.2 : 1
      const res = Math.round(runeSpecialFactor.chasing.extraValue * mag * extraValue)
      return `额外伤害 + <span class="grow">${res}</span>`
    },
  },
  heavyInjury: {
    name: '重创',
    desc: ({ extraValue }, soulType) => {
      const mag = soulType === 1 ? 1.2 : 1
      const res = Math.round(runeSpecialFactor.heavyInjury.extraValue * mag * extraValue)
      return `额外伤害 + <span class="grow">${res}</span>`
    },
  },
  break: {
    name: '破阵',
    desc: ({ extraMultiplier }, soulType) => {
      const mag = soulType === 1 ? 1.2 : 1
      const res = Number((runeSpecialFactor.break.extraMultiplier * mag * extraMultiplier).toFixed(2))
      return `攻击加成 + <span class="grow">${res}</span> %`
    },
  },
  crushBone: {
    name: '碎骨',
    desc: ({ extraRate, extraMag }, soulType) => {
      const mag = soulType === 3 ? 1.2 : 1
      if (extraRate) {
        const res = Number((runeSpecialFactor.crushBone.extraRate * mag * extraRate).toFixed(2))
        return `触发概率增加 <span class="grow">${res}</span> 倍`
      } else {
        const res = Number((runeSpecialFactor.crushBone.extraMag * mag * extraMag).toFixed(2))
        return `忽略防御增加 <span class="grow">${res}</span> 倍`
      }
    },
  },
  burst: {
    name: '爆发',
    desc: ({ extraRate }, soulType) => {
      const mag = soulType === 2 ? 1.2 : 1
      const res = Number((runeSpecialFactor.burst.extraRate * mag * extraRate).toFixed(2))
      return `概率 + <span class="grow">${res}%</span>`
    },
  },
  nothingness: {
    name: '虚无',
    desc: ({ extraMultiplier }, soulType) => {
      const mag = soulType === 2 ? 1.2 : 1
      const res = Number((runeSpecialFactor.nothingness.extraMultiplier * mag * extraMultiplier).toFixed(2))
      return `转换比例 + <span class="grow">${res}%</span>`
    },
  },
  split: {
    name: '分裂',
    desc: ({ extraRate }, soulType) => {
      const mag = soulType === 2 ? 1.2 : 1
      const res = Number((runeSpecialFactor.split.extraRate * mag * extraRate).toFixed(2))
      return `概率 + <span class="grow">${res}</span> 倍`
    },
  },
  cruel: {
    name: '残忍',
    desc: ({ extraValue, extraMultiplier }, soulType) => {
      const mag = soulType === 1 ? 1.2 : 1
      if (extraValue) {
        const res = Math.round(runeSpecialFactor.cruel.extraValue * mag * extraValue)
        return `忽略防御增加 <span class="grow">${res}</span>`
      } else {
        const res = Number((runeSpecialFactor.cruel.extraMultiplier * mag * extraMultiplier).toFixed(2))
        return `忽略防御增加 <span class="grow">${res}%</span>`
      }
    },
  },
  shadowBlade: {
    name: '影刃',
    desc: ({ extraValue, extraMultiplier }, soulType) => {
      const mag = soulType === 2 ? 1.2 : 1
      if (extraValue) {
        const res = Math.round(runeSpecialFactor.shadowBlade.extraValue * mag * extraValue)
        return `额外伤害 + <span class="grow">${res}</span>`
      } else {
        const res = Number((runeSpecialFactor.shadowBlade.extraMultiplier * mag * extraMultiplier).toFixed(2))
        return `额外百分比伤害 + <span class="grow">${res}%</span>`
      }
    },
  },
  swiftness: {
    name: '轻灵',
    desc: ({ extraValue }, soulType) => {
      const mag = soulType === 3 ? 1.2 : 1
      const res = Number((runeSpecialFactor.swiftness.extraValue * mag * extraValue).toFixed(3))
      return `攻击速度加成 + <span class="grow">${res}</span> 倍`
    },
  },
  precise: {
    name: '精准',
    desc: ({ extraMultiplier }, soulType) => {
      const mag = soulType === 3 ? 1.2 : 1
      const res = Number((runeSpecialFactor.precise.extraMultiplier * mag * extraMultiplier).toFixed(2))
      return `忽略闪避率 + <span class="grow">${res}%</span>`
    },
  },
  rout: {
    name: '击溃',
    desc: ({ extraValue, extraMultiplier }, soulType) => {
      const mag = soulType === 2 ? 1.2 : 1
      if (extraValue) {
        const res = Number((runeSpecialFactor.rout.extraValue * mag * extraValue).toFixed(2))
        return `额外降低抗暴率 + <span class="grow">${res}%</span>`
      } else {
        const res = Number((runeSpecialFactor.rout.extraMultiplier * mag * extraMultiplier).toFixed(2))
        return `额外降低抗暴率的 <span class="grow">${res}%</span>`
      }
    },
  },
  tearInjury: {
    name: '裂创',
    desc: ({ extraValue }, soulType) => {
      const mag = soulType === 2 ? 1.2 : 1
      const res = Math.round(runeSpecialFactor.tearInjury.extraValue * mag * extraValue)
      return `额外伤害 + <span class="grow">${res}</span>`
    },
  },
  impact: {
    name: '冲击',
    desc: ({ extraHpPercent, extraMag }, soulType) => {
      const mag = soulType === 1 ? 1.2 : 1
      if (extraHpPercent) {
        const res = Number((runeSpecialFactor.impact.extraHpPercent * mag * extraHpPercent).toFixed(2))
        return `触发条件降低 <span class="grow">${res}</span> 倍`
      } else {
        const res = Number((runeSpecialFactor.impact.extraMag * mag * extraMag).toFixed(2))
        return `忽略防御增加 <span class="grow">${res}</span> 倍`
      }
    },
  },
  windUp: {
    name: '收尾',
    desc: ({ extraHpPercent, extraMag }, soulType) => {
      const mag = soulType === 3 ? 1.2 : 1
      if (extraHpPercent) {
        const res = Number((runeSpecialFactor.windUp.extraHpPercent * mag * extraHpPercent).toFixed(2))
        return `触发条件降低 <span class="grow">${res}</span> 倍`
      } else {
        const res = Number((runeSpecialFactor.windUp.extraMag * mag * extraMag).toFixed(2))
        return `忽略防御增加 <span class="grow">${res}</span> 倍`
      }
    },
  },
}

export function explainRuneAffix(affixList: RuneSpecAttrType[], soulType: number) {
  return affixList.map((item) => {
    const equipAffix = runeAffixCollection[item.key]
    const name = equipAffix.name
    const desc = equipAffix.desc(item.data, soulType)
    return `<span class="special">${name}</span>${desc}`
  })
}
